import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface BusinessType {
    id: number;
    name: string;
    status?: number;
    default?: number;
    package?: number;
    package_name?: string;
    recommend_state: number;
    recommend_state_name: string
}

export const businessTypeApi = createApi({
  reducerPath: "businessTypeApi",
  baseQuery: baseQueryWithReAuth,
  endpoints: (builder) => ({
    getBusinessTypes: builder.query<BusinessType[], void>({
      query: () => "/business-type/",
    }),
  }),
});

export const { useGetBusinessTypesQuery } = businessTypeApi;
